import './ShareButton.scss';
import React, { useState } from 'react';
import { ucFirst } from '../Utils/caseconverters';
import classNames from 'classnames';
import { ReactComponent as ShareIcon } from '../../images/share.svg';

function ShareButton({ colorTheme, title, light }) {
  const [expanded, setExpanded] = useState(false);
  const [hovering, setHovering] = useState(false);

  return (
    <div className="ShareButton"
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
    >
      <div className={classNames(
        "ShareButton__Button",
        `ShareButton__Button--${ucFirst(colorTheme)}`, {
        "ShareButton__Button--Light": light,
        "ShareButton__Button--Expanded": expanded || hovering
      })}
      >
        {!expanded && !hovering
          ? <span className="ShareButton__Text">{title}</span>
          : <ShareOptions
            colorTheme={colorTheme}
            light={light}
          />
        }

        <ShareIconButtonWithCircle
          expanded={(expanded || hovering)}
          title={title}
          colorTheme={colorTheme}
          light={light}
          toggleExpanded={() => setExpanded(!expanded)}
        />
      </div>
    </div>
  )
}

const ShareOptions = ({ colorTheme, light }) => {
  const handleLinkOnClick = (target) => {
    switch (target) {
      case "facebook":
        window.open("https://www.facebook.com/sharer/sharer.php?u=" + window.location.href, "_blank", "width=600,height=400");
        break;
      case "x":
        window.open("https://x.com/intent/tweet?url=" + window.location.href, "_blank", "width=600,height=400");
        break;
      case "linkedin":
        window.open("https://www.linkedin.com/sharing/share-offsite/?url=" + window.location.href, "_blank", "width=600,height=400");
        break;
      case "mail":
        window.location.href = "mailto:?subject=" + document.title + "&body=" + window.location.href;
        break;
      default:
        break;
    }
  }

  return (
    <div className={classNames(
      "ShareButton__Options",
      `ShareButton__Options--${ucFirst(colorTheme)}`, {
      "ShareButton__Options--Light": light
    })}
    >
      <button className="ShareButton__Option ShareButton__Option--X" onClick={() => handleLinkOnClick("x")}>
        <i className="fa-brands fa-x-twitter"></i>
      </button>
      <button className="ShareButton__Option ShareButton__Option--Facebook" onClick={() => handleLinkOnClick("facebook")}>
        <i className="fa-brands fa-facebook"></i>
      </button>
      <button className="ShareButton__Option ShareButton__Option--LinkedIn" onClick={() => handleLinkOnClick("linkedin")}>
        <i className="fa-brands fa-linkedin"></i>
      </button>
      <button className="ShareButton__Option ShareButton__Option--Mail" onClick={() => handleLinkOnClick("mail")}>
        <i className="fa-sharp fa-solid fa-envelope"></i>
      </button>
    </div>
  )
}

const ShareIconButtonWithCircle = ({ colorTheme, light, toggleExpanded, expanded, title }) => (
  <button aria-label={title} className={classNames(
    "ShareButton__Circle",
    `ShareButton__Circle--${ucFirst(colorTheme)}`, {
    "ShareButton__Circle--Light": light,
    "ShareButton__Circle--Expanded": expanded
  })}

    onClick={() => toggleExpanded(!expanded)}
  >
    <ShareIcon />
  </button>
)

ShareButton.defaultProps = {
  colorTheme: "",
  light: false,
};

export default ShareButton;
